import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import ButtonBase from '../../Buttons/ButtonBase';
import Select from '../../SimpleSelect/Select';
import municipios from './estados-municipios.json'
import estados from './estados.json';

import './addSite.scss';

const styles = () => ({
  TextField: {
    maxWidth: '512px',
  },
  TextField_small: {
    maxWidth: '144px',
    marginRight: '24px',
  },
  input_icon: { 
    maxWidth: '560px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  ButtonBase: {
    '@media (max-width:580px)': {
      minWidth: 136
    }
  },
});

const SiteForm = props => {
  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    resetForm,
    isValid,
    classes,
    setFieldValue,
    evento,
    edit,
  } = props;

  const [availableState, setAvailableState] = useState(estados);
  const [availableCities, setAvailableCities] = useState([]);

  useEffect(() => {
    (async function() {
    if(values.estado !== "" && edit){
      let states = values.estado
      let cities = await municipios[states];
      let datos = [];
      let objeto = {};
      for (let i in cities) {
        let municipios = cities[i]
        datos.push({ value: municipios, label: municipios })
      }
      objeto.datos = datos;
      setAvailableCities(datos);
    }
  })();
  }, [edit, values.estado]);

  const handleCancel = event => {
    event.preventDefault();
    resetForm();
    evento();
  };

  const handleStates =   (field)  =>async (event) => {

    let states = event.target.value
    let cities = await municipios[states];
    let datos = [];
    let objeto = {};
    for (let i in cities) {
      let municipios = cities[i]
      datos.push({ value: municipios, label: municipios })
    }
    objeto.datos = datos;
     setAvailableCities(datos);
     setFieldValue(field, states);
  }
  
  const handleCities = field => async event => {
    let value = event.target.value;
    setFieldValue(field, value);
  }


  return (
    <form className={classes.form}>
      <Select
        handleBlur={handleBlur}
        handleChange={handleStates('estado')}
        value={values.estado}
        touchedItems={touched.estado}
        errorsItems={errors.estado}
        items={availableState}
        textLabel="Estado*"
        className={classes.TextField}
        attrib='512px'
      />

      <Select
        handleBlur={handleBlur}
        handleChange={handleCities('municipio')}
        value={values.municipio}
        touchedItems={touched.municipio}
        errorsItems={errors.municipio}
        items={availableCities}
        textLabel="Municipio*"
        className={classes.TextField}
        attrib='512px'
      />
      
      <TextField
        label="Dirección*"
        id="direccion"
        type="text"
        variant="outlined"
        onBlur={handleBlur}
        onChange={handleChange}
        value={values.direccion}
        helperText={
          touched.direccion && errors.direccion ? errors.direccion : ''
        }
        error={touched.direccion && errors.direccion ? true : false}
        fullWidth
        classes={{ root: classes.TextField }}
      />

      <div className="addSite-horizontal-layout" style={{ marginTop: 15 }}>
        <div style={{ display: 'flex' }}>
          <ButtonBase
            type="submit"
            onClick={handleSubmit}
            variant="primary"
            disabled={!isValid}
            className={classes.ButtonBase }
            style={{ marginRight: 16 }}
          >
            {values.flagEdit ? 'Guardar' : 'Agregar'}
          </ButtonBase>

          <ButtonBase
            type="submit"
            onClick={handleCancel}
            variant="primaryOutlined"
            // disabled={!isValid}
            className={classes.ButtonBase }
            style={{ marginRight: 16 }}
          >
            Cancelar
          </ButtonBase>
        </div>
      </div>
    </form>
  );
};

export default withStyles(styles)(SiteForm);
